// 9fbef606107a605d69c0edbcd8029e5d
import getCustomerGiftCardBalance from '@tcp/core/src/queries/getCustomerGiftCardBalance.query.graphql';
import logger from '@tcp/core/src/utils/loggerInstance';
import { executeStatefulGraphQLQuery } from '../../handler';

const getGiftCardBalanceApi = (payload) => {
  const { card, formData } = payload;

  const reqObject = {
    getCustomerGiftCardBalanceGiftCardRequestDto: {
      recaptureResponse: formData.recaptchaToken,
      paymentInstrumentId: card.creditCardId,
    },
  };

  return executeStatefulGraphQLQuery({
    query: getCustomerGiftCardBalance,
    variables: reqObject,
    type: 'query',
  })
    .then((res) => {
      return {
        res,
        statusCode: 200,
      };
    })
    .catch((err) => {
      logger.error(err);
      throw err;
    });
};

export default getGiftCardBalanceApi;
